<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <div id="navLogoBrand">
        <a href="/my/dashboard" class="logo"></a>
      </div>
    </div>
    <menu-burger v-if="this.$mq.phone" :links="menuLinks"></menu-burger>
    <template v-else>
      <div class="nav-items">
        <router-link
          v-for="item in visibleMenuItems"
          :key="item.id"
          :to="item.toRoute"
          :id="item.id"
          :class="getVisibleMenuItemClass(item)"
          class="paragraph-m paragraph-bold"
        >{{ item.name }}</router-link>
      </div>
      <menu-dropdown v-if="isCandidate" :links="menuLinks"></menu-dropdown>
      <menu-auth v-else-if="isEmployerUser" :links="employerMenu"></menu-auth>
      <menu-auth v-else :links="authMenu"></menu-auth>
    </template>
  </nav>
</template>

<script>

import {b2c} from 'top20common/distribution/constants/scopes';
import redirects from 'top20common/distribution/services/redirects';
import {mapGetters} from 'vuex';

import MenuAuth from './MenuAuth';
import MenuBurger from './MenuBurger';
import MenuDropdown from './MenuDropdown';

export default {
  data() {
    return {
      authMenu: [
        this.getMenuItem({name: this.$gettext('Login'), click: this.loginClick}),
        this.getMenuItem({name: this.$gettext('Sign up'), click: this.signUpClick})
      ],
      employerMenu: [this.getMenuItem({name: this.$gettext('Employer logout'), click: this.logout})]
    };
  },
  computed: {
    ...mapGetters(['featureSwitchesState', 'jobDetailsState', 'isEmployerUser']),
    isCandidate() {
      return this.$store.getters.userScopesState.includes(b2c);
    },
    menuLinks() {
      return this.isCandidate ? this.candidateMenu : [...this.visibleMenuItems, ...this.authMenu];
    },
    dashboardLink() {
      return this.getMenuItem({
        name: this.$gettext('Dashboard'),
        toRoute: {name: 'dashboard'},
        click: this.dashboardClick,
        id: 'dashboard'
      });
    },
    jobsLink() {
      const toRoute = this.isPageTop20techSourced ? {name: 'jobs', query: {source: 'top20tech'}} : {name: 'jobs'};
      const click = () => {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$router.push(toRoute);
      };
      return this.getMenuItem({name: this.$gettext('Jobs'), toRoute, click, id: 'jobs-link'});
    },
    candidateMenu() {
      let menu = [
        this.getMenuItem({name: this.$gettext('Edit profile'), click: this.editProfileClick}),
        this.getMenuItem({name: this.$gettext('Change Password'), click: this.changePasswordClick}),
        this.getMenuItem({name: this.$gettext('Logout'), click: this.logout})
      ];
      if (this.$mq.phone) {
        return [...this.visibleMenuItems, ...menu];
      }
      return menu;
    },
    visibleMenuItems() {
      return this.isCandidate ? [this.dashboardLink, this.jobsLink] : [this.jobsLink];
    },
    isPageTop20techSourced() {
      return (
        this.$route.query.source === 'top20tech' || (this.$route.name === 'job' && this.jobDetailsState.is_top20tech)
      );
    }
  },
  methods: {
    getMenuItem({name, click, toRoute, id}) {
      return {name, click, toRoute, id};
    },
    changePasswordClick() {
      this.$mam.trackNavChangePasswordClicked();
      redirects.goToChangePassword(this.$store, this.$route.name, this.$route.fullPath);
    },
    loginClick() {
      this.$mam.trackNavLoginClicked();
      redirects.saveTargetRouteBeforeLogin(this.$route.fullPath);
      redirects.goToCandidateLogin(this.$store, this.$route.name, this.$route.fullPath);
    },
    signUpClick() {
      this.$mam.trackNavSignUpClicked();
      const queryParams = this.isPageTop20techSourced ? 'source=top20tech' : '';
      redirects.goToCandidateRegister(this.$store, this.$route.name, this.$route.fullPath, queryParams);
    },
    logout() {
      this.$mam.trackNavLogoutClicked();
      this.$store.dispatch('logoutUserAction');
      this.$mam.reset();
      redirects.goToCandidateLogin();
    },
    editProfileClick() {
      this.$mam.trackNavEditProfileClicked();
      this.$router.push({name: 'edit-basic-profile-data'});
    },
    dashboardClick() {
      this.$router.push({name: 'dashboard'});
    },
    getVisibleMenuItemClass(item) {
      const activeClass = 'underline-active';
      if (this.$route.name === item.toRoute.name) {
        return [activeClass];
      }
    }
  },
  components: {MenuDropdown, MenuBurger, MenuAuth}
};
</script>
<style lang="scss" scoped>
.navbar {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 10;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
}

.nav-items {
  flex-grow: 1;
  flex-direction: row;
  display: flex;
  a {
    display: inline-block;
    margin-right: 30px;
    margin-left: 30px;
    color: var(--primary);
  }
  a.underline-active {
    color: var(--secondary);
    border-bottom: 2px solid var(--secondary);
  }
}

.link {
  cursor: pointer;
  margin-left: 30px;
}
</style>
